import React from 'react';
import MaskedInput from 'react-text-mask';
import { StyledTextbox } from '@nib-components/textbox';
import BaseFormField from '../base-form-field';
import { AddFunnelPropFromContext } from '../funnel-context';
import { LABELS as DEFAULT_LABELS, FUNNELS, DEFAULT_MASK } from '../../util/constants';
import { defaultFieldPropTypes } from '../../types';
const LABELS = {
  ARHI: DEFAULT_LABELS.FIRST_NAME,
  IMAN: DEFAULT_LABELS.GIVEN_NAME,
  IWHI: DEFAULT_LABELS.GIVEN_NAME,
  ISHI: DEFAULT_LABELS.GIVEN_NAME
};
export const FirstName = props => {
  /*  react-text-mask has issues updating its own internal component when the mask value is false
   *  This issue is mainly only ever seen when we dynamically change the value of the field through
   *  events such as adding / removing children (formik field array) and when we don't provide a mask - mask={false}
   *  Using a workaround for now - pass in a mask function that accepts everything to work as before.
   */
  var _a;
  // allow any type of character function so that the component has a mask
  const {
    funnel = FUNNELS.ARHI,
    help = '',
    width = 20,
    optional = false,
    required
  } = props;
  const mask = ((_a = props.mask) === null || _a === void 0 ? void 0 : _a.length) ? props.mask : DEFAULT_MASK;
  return React.createElement(BaseFormField, {
    ...props,
    label: props.label || LABELS[funnel] || LABELS.ARHI,
    funnel: funnel,
    width: width,
    help: help,
    optional: optional,
    required: required
  }, React.createElement(MaskedInput, {
    guide: false,
    mask: mask,
    ...props.field,
    render: (ref, props) => React.createElement(StyledTextbox, {
      ref: ref,
      ...props,
      inputMode: "text",
      autoComplete: "given-name"
    })
  }));
};
FirstName.defaultProps = {
  ...defaultFieldPropTypes,
  mask: []
};
const FirstNameWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(FirstName, {
  ...props
}));
export default FirstNameWithFunnel;